import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppStreamingAdmin from './AppStreamingAdmin';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AppStreamingAdmin />
  </BrowserRouter>
);

reportWebVitals();
